import usePosterShare from "@/hooks/useShare/usePosterShare";
import { BridgeClientShareReportKeys, ModulesMappings } from "@/interfaces/enums";
import { useGetShareCode } from "@/service/pullNew.service";
import getFullWebCdnUrl from "@/utils/getFullWebCdnUrl";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import QRCode from "qrcode";
import React, { useImperativeHandle } from "react";
import { ForwardedRef, useEffect, useRef, useState } from "react";
enum ShareTypes {
	AVATSTR = 1,
	COVER = 2,
}

interface Props {
	imgUrl: string;
	type: ShareTypes;
}

function NFTShare(
	props: Props,
	ref: ForwardedRef<{
		handleShare: () => void;
	}>,
) {
	const { t } = useTranslation("share");
	const { locale } = useRouter();
	const targetRef = useRef<HTMLDivElement>(null);
	const [qrImg, setQrImg] = useState<string>("");
	const onShare = usePosterShare();
	const { shareCode = "" } = useGetShareCode();

	useImperativeHandle(ref, () => ({
		handleShare,
	}));

	const setImg = async () => {
		const url = getLinkUrl();
		const str = await QRCode.toDataURL(url, {
			width: 520,
			margin: 1,
			errorCorrectionLevel: "Q",
		});
		setQrImg(str);
	};

	const getShareTemplate = () => {
		const prefix = ["en", "zh-Hans"].find((item) => item === (locale as string));
		return getFullWebCdnUrl(`/share/nft-poster-${prefix || "en"}.webp`);
	};

	const handleShare = () => {
		if (!targetRef.current) return;
		if (!props.imgUrl) return;
		const subtitle = t(`${getModuleKey()}-sub-title`, {
			inviteCode: shareCode,
		});

		const shareScene =
			props.type === ShareTypes.AVATSTR
				? BridgeClientShareReportKeys.NTF_AVATAR_SHARE
				: BridgeClientShareReportKeys.NTF_COVER_SHARE;

		const linkUrl = getLinkUrl();
		return onShare(targetRef.current, {
			subtitle,
			shareScene,
			linkUrl,
			shareCode,
		});
	};

	const getModuleKey = () => {
		return props.type === ShareTypes.AVATSTR ? ModulesMappings.avatar2022 : ModulesMappings.cover2022;
	};
	const getLinkUrl = () => {
		if (typeof window === "undefined") {
			return "";
		}
		const domain = window.location.origin;
		const type = props.type === ShareTypes.AVATSTR ? "at" : "cv";
		return `${domain.replace(".ai", ".tech")}/${locale}/intents/download?inviteCode=${shareCode}&h=${type}`;
	};

	useEffect(() => {
		if (typeof window === "undefined") return;
		setImg();
	}, [props.imgUrl]);

	return (
		<div className="fixed -left-[499999.5px]">
			<div className="relative h-[931px] w-[540px]" style={{ color: "#AB48FE" }} ref={targetRef}>
				<img src={getShareTemplate()} alt="" className="h-full w-full" />
				<div className="absolute left-[25px] top-[318px] h-[365px] w-[365px] p-2.5">
					<img src={props.imgUrl} className="h-full w-full object-cover" alt="imgUrl" />
				</div>

				<div className="absolute left-0 top-[160px] w-full px-[35px] text-left text-[40px] font-normal leading-[1.2] ">
					{t("who-says-value-investing-is")}
				</div>

				<div className="absolute bottom-[72.5px] left-[38.5px] text-left">
					<p className="text-2xl font-normal ">{t("invite-code", { ns: "common" })}</p>
					<p className="text-[52.5px] font-bold leading-[55.75px] " style={{ letterSpacing: "9px" }}>
						{shareCode}
					</p>
				</div>

				<div className="absolute bottom-[25px] right-[29px] h-[145px] w-[145px] p-1">
					<img src={qrImg} alt="qrcode" className="h-full w-full object-cover" />
				</div>
			</div>
		</div>
	);
}

export default React.forwardRef(NFTShare);
